<template>
  <div
    class="flex flex-col items-center mb-4 leading-normal"
    data-component="PhoneCall"
    :data-id="phoneCall.id"
  >
    <div class="max-w-6/10 rounded"
      :class="[involvesCurrentUser ? 'bg-cardstock-yellow-500' : 'bg-gray-300']"
    >
      <div class="p-3 text-sm text-center">
        {{narrative}} <span class="font-bold">{{displayName}}</span> at {{formattedTimestamp}}
      </div>
    </div>
  </div>
</template>

<script>
import parse from 'date-fns/parse'
import format from 'date-fns/format'
import _get from 'lodash-es/get'
import _capitalize from 'lodash-es/capitalize'

export default {

  props: {
    communication: {
      required: true
    }
  },

  data() {
    return {
      isEditing: false,
      proposedNotes: '',
      phoneCall: {}
    }
  },

  mounted() {
    this.phoneCall = this.communication
  },

  methods: {
    didClickEdit() {
      this.isEditing = true
      this.proposedNotes = this.notes
    },

    didClickSave() {
      this.isEditing = false
    }
  },

  computed: {
    canEdit() {
      return _get(this.phoneCall, 'canEdit')
    },

    displayName() {
      if (this.involvesCurrentUser) {
        return 'me'
      } else {
        return _get(this.phoneCall, 'conversation.teacherPhoneNumber.displayName')
      }
    },

    formattedTimestamp() {
      const date = parse(this.phoneCall.insertedAt)
      return format(date, 'h:mm a')
    },

    involvesCurrentUser() {
      return _get(this.phoneCall, 'involvesCurrentUser')
    },

    isIncoming() {
      return _get(this.phoneCall, 'direction') == "incoming"
    },

    narrative() {
      if (this.isIncoming) {
        return 'Call to '
      } else {
        return 'Call by '
      }
    },

    notes() {
      return _get(this.phoneCall, 'notes')
    },

    teacherPhoneNumber() {
      return _get(this.phoneCall, 'teacherPhoneNumber')
    }
  },


}
</script>
